
/*
 2FA input handler using keydown for individual digit input, paste for distribution, and backspace navigation.
 Handles fast typing by processing each key press individually.
*/

$(document).ready(function () {
    $('.not-first').prop('disabled', true);
    // if we're showing the 2FA modal, focus the first input
    $('#modal-2fa').on('shown.bs.modal', function () {
        $('#2fa-input-1').removeAttr('disabled').focus().select();
    });
});

$(function () {
    'use strict';
    var body = $('body');

    // helper: get all inputs in order
    function inputsFor(el) {
        var $form = $(el).closest('form');
        var $inputs = $form.find('input[data-2fa]');
        if (!$inputs.length) $inputs = $('input[data-2fa]');
        return $inputs;
    }

    // helper: enable and set value for an input index
    function setInputAt($inputs, idx, ch) {
        var $i = $($inputs.get(idx));
        if (!$i || !$i.length) return;
        $i.removeAttr('disabled').val(ch);
    }

    // Move focus to next empty input or keep at end
    function focusNextEmpty($inputs, startIdx) {
        for (var j = startIdx; j < $inputs.length; j++) {
            var $el = $($inputs.get(j));
            if (!$el.val()) {
                $el.removeAttr('disabled').focus().select();
                return;
            }
        }
        // none empty: enable verify
        $('.btn-verify').prop('disabled', false);
    }    // focus selects content
    body.on('focus click', 'input[data-2fa]', function (e) { $(e.target).select(); });

    // keydown: handle digits, backspace
    body.on('keydown', 'input[data-2fa]', function (e) {
        var key = e.which || e.keyCode;
        var $t = $(e.target);
        var $inputs = inputsFor($t);
        var curIdx = $inputs.index($t);

        if ((key >= 48 && key <= 57) || (key >= 96 && key <= 105)) { // digits 0-9 (main and numpad)
            e.preventDefault();
            var digit = String.fromCharCode(key >= 96 ? key - 48 : key); // adjust for numpad
            setInputAt($inputs, curIdx, digit);
            focusNextEmpty($inputs, curIdx + 1);
        } else if (key === 8) { // backspace
            e.preventDefault();
            if ($t.val()) {
                $t.val('');
            } else {
                // move to previous
                var $prev = $t.prevAll('input[data-2fa]').first();
                if ($prev && $prev.length) {
                    $prev.val('').focus().select();
                }
            }
        } else if (key === 9) { // tab: allow default
            return;
        } else if (e.ctrlKey && key === 86) { // allow Ctrl+V
            return;
        } else if (key === 13) { // allow Enter
            return;
        } else {
            // ignore other keys
            e.preventDefault();
        }
    });

    // paste: distribute pasted digits
    body.on('paste', 'input[data-2fa]', function (e) {
        e.preventDefault();
        var $t = $(e.target);
        var $inputs = inputsFor($t);
        var curIdx = $inputs.index($t);
        var pasted = (e.originalEvent || e).clipboardData.getData('text');
        var digits = pasted.replace(/\D/g, '');
        for (var i = 0; i < digits.length && (curIdx + i) < $inputs.length; i++) {
            setInputAt($inputs, curIdx + i, digits.charAt(i));
        }
        focusNextEmpty($inputs, curIdx + digits.length);
    });

    // composition (IME) handling: allow composition but handle on compositionend
    var composing = false;
    body.on('compositionstart', 'input[data-2fa]', function () { composing = true; });
    body.on('compositionend', 'input[data-2fa]', function (e) {
        composing = false;
        var $t = $(e.target);
        var $inputs = inputsFor($t);
        var curIdx = $inputs.index($t);
        var val = ($t.val() || '').toString().replace(/\D/g, '');
        // distribute the composed text
        for (var i = 0; i < val.length && (curIdx + i) < $inputs.length; i++) {
            setInputAt($inputs, curIdx + i, val.charAt(i));
        }
        focusNextEmpty($inputs, curIdx + val.length);
    });

    // input event as fallback for any missed input
    body.on('input', 'input[data-2fa]', function (e) {
        if (composing) return;
        var $t = $(e.target);
        var $inputs = inputsFor($t);
        var idx = $inputs.index($t);
        var val = ($t.val() || '').toString().replace(/\D/g, '');
        if (!val) return;
        // set current and move
        setInputAt($inputs, idx, val.charAt(0));
        if (val.length > 1) {
            // distribute rest
            for (var k = 1; k < val.length && (idx + k) < $inputs.length; k++) {
                setInputAt($inputs, idx + k, val.charAt(k));
            }
        }
        focusNextEmpty($inputs, idx + val.length);
    });

});

